import React from 'react';
import classNames from 'classnames';
import { number, object } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';

const MilestonePrice = ({ milestoneNumber, priceInUsd }, { currencyConverter }) => {
    if (!priceInUsd) { return null; }

    const priceInCents = priceInUsd * 100;
    const formattedPrice = currencyConverter.convert(priceInCents);
    const isFirstMilestone = milestoneNumber === 1;
    const paymentSuffix = isFirstMilestone
        ? 'pay_now'
        : 'pay_later';
    const paymentKey = `gig_page_perseus.workProcess.milestone.price.${paymentSuffix}`;

    return (
        <div className={classNames('tbody-7', 'milestone-price')}>
            <b className="tbody-5">{formattedPrice}</b>
            <span className={classNames({ 'first-milestone': isFirstMilestone })}>
                <I18n k={paymentKey}/>
            </span>
        </div>
    );
};

MilestonePrice.propTypes = {
    milestoneNumber: number,
    priceInUsd: number
};

MilestonePrice.contextTypes = {
    currencyConverter: object
};

export default MilestonePrice;
